/**
 * 效果调度(方案 G2):同心跳多事件按队列错峰 1.5~3s 启动;
 * 同 exclusiveGroup 互斥(新效果令旧效果 resolve);ceremony 独占全场,期间暂停队列。
 */
import type { OracleEffect } from './base';
import { EFFECT_CLASSES, DEFAULT_DUR, EFFECT_META } from './registry';

/** 互斥组内的优先级:低阶效果不得顶掉高阶(修"45条天晴把天空撕裂秒掉"事故) */
const TIER_W: Record<string, number> = { 轻: 1, 中: 2, 大: 3, 戏剧: 4, 安全: 1 };

interface Pending { id: string; k: number; dur?: number; meta?: any; }

export class EffectManager {
  private active: OracleEffect[] = [];
  private queue: Pending[] = [];
  private stagger = 0;

  trigger(id: string, k = 0.6, dur?: number, meta?: any) {
    this.queue.push({ id, k, dur, meta });
  }

  update(dt: number) {
    const ceremonyActive = this.active.some((e) => e.exclusiveGroup === 'ceremony');
    this.stagger -= dt;
    if (this.queue.length && this.stagger <= 0 && !ceremonyActive) {
      this.startNext();
      this.stagger = 1.5 + Math.random() * 1.5;
    }
    for (let i = this.active.length - 1; i >= 0; i--) {
      const e = this.active[i];
      e.update(dt);
      if (e.done) { e.destroy(); this.active.splice(i, 1); }
    }
  }

  private startNext() {
    const p = this.queue.shift()!;
    const Cls = EFFECT_CLASSES[p.id];
    if (!Cls) return;                        // 未实现:安全跳过(§3b 补齐)
    const e = new Cls();
    if (e.exclusiveGroup) {
      const wNew = TIER_W[EFFECT_META[p.id]?.tier ?? '轻'] ?? 1;
      for (const a of this.active) {
        if (a.exclusiveGroup !== e.exclusiveGroup) continue;
        const wOld = TIER_W[EFFECT_META[a.id]?.tier ?? '轻'] ?? 1;
        // 新效果阶位更低 → 丢弃新效果,让高阶(如天空撕裂)演完;否则顶掉旧的
        if (wNew < wOld) { e.destroy(); return; }
        a.resolve();
      }
    }
    e.start(p.k, p.dur ?? DEFAULT_DUR[p.id] ?? 15, p.meta);
    this.active.push(e);
  }

  get activeCount() { return this.active.length; }
  clear() { for (const e of this.active) e.destroy(); this.active = []; this.queue = []; }
}
